import { queryKeys } from './useQueryWorkspace'
import { useFetchWorkspace } from './useFetchWorkspace'
import { useQueryClientUtils } from '../useQueryClientUtils'
import { queryKeys as onboardingTaskQueryKeys } from '../onboarding-task/useQueryOnboardingTask'
import { queryKeys as queryKeysLegalScoreCategory } from '../legal-score/category/useQueryLegalScoreCategory'

const update = () => {
  const { update: mutationFn } = useFetchWorkspace()
  const { fetchActiveWorkspaceData, workspace } = useAuth()
  const { invalidateQueries, cancelQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn,
    onMutate: (variables) => {
      cancelQueries([
        queryKeys.all._def,
        onboardingTaskQueryKeys.all(variables).queryKey,
      ])
    },
    onSuccess: (_, { meta }) => {
      // workaround for not having proper cache invalidation in place. The employee_amount should be updated immediately to have the right value in the UI
      if (!workspace.value?.relationships?.businessProfile // should be there as this is a required relationship
        || !meta?.businessProfile
      ) {
        return
      }

      if ('employee_amount' in meta.businessProfile)
        workspace.value.relationships.businessProfile.data.attributes.employee_amount = meta?.businessProfile?.employee_amount

      if ('shareholder_amount' in meta.businessProfile)
        workspace.value.relationships.businessProfile.data.attributes.shareholder_amount = meta?.businessProfile?.shareholder_amount

      if ('collects_personal_data' in meta.businessProfile)
        workspace.value.relationships.businessProfile.data.attributes.collects_personal_data = meta?.businessProfile?.collects_personal_data
    },
    onSettled: (_, _1, { workspaceId, meta }) => {
      fetchActiveWorkspaceData({ refresh: true })

      const hasBusinessProfileUpdates = meta && 'businessProfile' in meta

      invalidateQueries([
        queryKeys.all._def,
        onboardingTaskQueryKeys.all({ workspaceId }).queryKey,
        ...(hasBusinessProfileUpdates ? [queryKeysLegalScoreCategory.all._def] : []),
      ])
    },
  })
}

const activatePartnership = () => {
  const { activatePartnership: mutationFn } = useFetchWorkspace()
  const { invalidateQueries, cancelQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn,
    onMutate: () => {
      cancelQueries([queryKeys.all._def])
    },
    onSuccess: () => {
      invalidateQueries([queryKeys.all._def])
    },
  })
}

export const useMutationWorkspace = {
  update,
  activatePartnership,
}
